import { inject, Injectable } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faArrowLeft,
  faArrowRight,
  faArrowRotateLeft,
  faBuilding,
  faBell,
  faChevronDown,
  faChevronRight,
  faCircleQuestion,
  faCopy,
  faDownload,
  faEye,
  faEyeSlash,
  faFile,
  faFileLines,
  faHouse,
  faLayerGroup,
  faLineChart,
  faPlus,
  faLink,
  faSave,
  faScaleBalanced,
  faSliders,
  faSort,
  faTableCellsLarge,
  faTag,
  faUpload,
  faUsers,
  faUser,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

@Injectable()
export class IconsLibraryService {
  private readonly _library = inject(FaIconLibrary);

  /**
   * Load all icons used in the application.
   */
  public register(): void {
    this._library.addIcons(
      faArrowLeft,
      faArrowRight,
      faArrowRotateLeft,
      faBuilding,
      faBell,
      faChevronDown,
      faChevronRight,
      faCircleQuestion,
      faCopy,
      faDownload,
      faEye,
      faEyeSlash,
      faFile,
      faFileLines,
      faHouse,
      faLayerGroup,
      faLineChart,
      faPlus,
      faScaleBalanced,
      faSliders,
      faSort,
      faTableCellsLarge,
      faTag,
      faUpload,
      faUsers,
      faUser,
      faXmark,
      faLink,
      faSave,
    );
  }
}
